import api from '@pray/shared/utils/api';

import { asPrayRadioRehosting, waitForPrayRadioAudioRehost } from './waitForPrayRadioAudioRehost';

/**
 * Copies an audio Content episode into a Pray Radio DailyItem (PB-37965).
 * Idempotent per content — re-picking the same episode reuses/refreshes the
 * existing copy. Returns { id, daily_series_id, artist_id, created } for the
 * DailyItem copy, ready to hand to the existing schedule flow.
 *
 * An episode hosted outside Pray first has its audio copied to Pray, which can
 * take several minutes: `onRehosting` fires when that starts, and the copy is
 * asked for again once it is done.
 */
export async function copyPrayRadioContentToDailyItem({
  artistId,
  contentId,
  onRehosting,
}: {
  artistId: string;
  contentId: string;
  onRehosting?: () => void;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');

  const url = `/web/studio/artists/${artistId}/pray-radio-dailies/copy-from-content`;
  let response = await api.executePostRequest(url, { content_id: contentId });

  const rehosting = asPrayRadioRehosting(response.data);
  if (rehosting) {
    onRehosting?.();
    await waitForPrayRadioAudioRehost({ artistId, processId: rehosting.process_id });
    response = await api.executePostRequest(url, { content_id: contentId });
  }

  return response.data;
}
